import { useState, useEffect, useRef } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetailParams } from "../../state/itemTypeEntrySlice";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CreateItemTypeEntry = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [submitBtnId, setSubmitBtnId] = useState("")
    const submitLockRef = useRef(false);//
    const { detailParams, isNewEntry } = useSelector((state) => state.itemTypeEntry);

    const [formData, setFormData] = useState({
        
        itemTypeId: 0,
        itemTypeName: "",
        stPer: 0,
        astPer: 0,
        hsnNo: ""
    });

    const { data: detail = [], isPending: isLoading, mutate: filterDetail } = usePost({
        url: apiRoute.itemType.fetchEntryDetail,
        queryKey: "fetchItemTypedetail",
    });

    useEffect(() => {
        if (detailParams && Object.keys(detailParams).length > 0) {
            filterDetail({
                data: {
                    item_typeid: detailParams.item_typeid
                }
            })
        }
    }, [detailParams]);

    useEffect(() => {
        if (!isNewEntry && detail && detail.length > 0) {
            setFormData({
                itemTypeId: detail[0].Item_Type_Id || 0,
                itemTypeName: detail[0].Item_Type_Name || "",
                stPer: detail[0].StPer || 0,
                astPer: detail[0].AstPer || 0,
                hsnNo: detail[0].HsnNo || "",
            });

        }
    }, [detail]);



    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const { mutate: funAddUpdate, isPending, isError } = usePost({
        queryKey: "ItemTypeAddUpdate",
        url: apiRoute.itemType.add_update,
        onSuccessTasks: () => {
            dispatch(resetDetailParams());
            submitLockRef.current = false;
            if (submitBtnId == 'btnSaveNew') {
                setFormData({
                    itemTypeId: 0,
                    itemTypeName: "",
                    stPer: 0,
                    astPer: 0,
                    hsnNo: ""
                })
            }
            else {

                navigate(linksUrl.master.itemType.itemTypeMaster);
            }
        },
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnId(e.nativeEvent.submitter.id)

        if (submitLockRef.current) return;
        submitLockRef.current = true;
        funAddUpdate({
            data: {
                ...formData,
                rec_status: !isNewEntry ? 1 : 2,
            }
        });

    };



    if (isLoading || isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <MainContainer
            pageName="Item type Entry"
            breadcrumbs={["Master", "Item Type Entry"]}
            prevPage={{ show: true, onClick: () => navigate(linksUrl.master.itemType.itemTypeMaster) }}
        >
            <Card className="p-6">
                <CardBody>
                    <form onSubmit={handleSubmit}>
                        <div className="grid gap-4">

                            <Input label="Item Type" variant="bordered" className="font-semibold text-slate-700" size="sm" name="itemTypeName" value={formData.itemTypeName} onChange={handleChange} isRequired />
                            <Input label="St Per" variant="bordered"
                                className=" text-slate-700" size="sm"
                                type="number" name="stPer" value={formData.stPer} onChange={handleChange} />
                            <Input label="Ast Per" variant="bordered" className="font-semibold text-slate-700" size="sm" type="number" name="astPer" value={formData.astPer} onChange={handleChange} />
                            <Input label="HSN No" variant="bordered" classNames="font-semibold text-slate-700" size="sm" name="hsnNo" value={formData.hsnNo} onChange={handleChange} />
                            <div className="flex gap-4 items-center justify-center">

                                <Button type="submit" id="btnSave" color="primary" size="sm" isLoading={isPending}>
                                    {isNewEntry ? "Save" : "Update"}
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="text-white"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>
                                <Button size="sm" onPress={() => navigate(linksUrl.master.itemGroup.itemGroupMaster)} color="danger" isLoading={isPending}>
                                    Cancle
                                </Button>
                            </div>
                        </div>
                    </form>

                </CardBody>
            </Card>
        </MainContainer>
    );
};

export default CreateItemTypeEntry;

